export function isReactElement(node: React.ReactNode): node is React.ReactElement {
    // biome-ignore lint/suspicious/noPrototypeBuiltins: legacy does not work (ts error) with Object.hasOwn
    return !!node && Object.prototype.hasOwnProperty.call(node, "type");
}
